
import { useCallback, useEffect } from 'react'

import { PERMITIONS } from 'components/DrawerMenu/routes_list'
import { useAuth, useLoading, useModal } from 'hooks'
import jwt from 'jsonwebtoken'
import { useHistory } from 'react-router-dom'
import { UserServices } from 'services/Supplier/Users'
import { createContext } from 'use-context-selector'

export const AuthContext = createContext<IAuthContext | null>(null)

export default function AuthProvider({ children }) {
  const { push } = useHistory()
  const { setLoading } = useLoading()
  const { showModal } = useModal()

  const {
    setAllData,
    token,
    setToken,
    setUser,
    setUsuarioCsn,
    setUsuarioFornecedor,
    allDatadescripted,
    setIsLogged,
    isLogged,
    setTipoUsuario
  } = useAuth() // REDUX

  /**
   *
   * LOGIN
   *
   */

  const handleLogin = async (requestLogin, hideLoader?: (boolean) => void) => {
    try {
      localStorage.clear();

      setLoading('loading')

      let response: any

      if (requestLogin.easterEgg) {
        response = await UserServices().easterEGGLogin()
      } else {
        response = await UserServices().login(requestLogin)
      }

      if (response.status !== 200 || !response.data.sucesso) {
        hideLoader && hideLoader(false)
        throw new Error(response.data.mensagem || 'Erro ao entrar no sistema.')
      }

    
     
      localStorage.setItem('csn-time', new Date().toString())
      localStorage.setItem('csn-rtk', response.data?.refreshToken)
      localStorage.setItem('csn-tk', response.data.token)
      localStorage.setItem('isCSN', requestLogin.isCsn)
      sessionStorage.setItem('csn-session', requestLogin.rememberMe)

      setToken(response.data.token)
      setIsLogged(true)

      setTimeout(() => {
        setLoading('idle')

        requestLogin.isCsn ? push('/ngt') : push('/fornecedor')
      }, 2000)
    } catch (error: any) {
      setLoading('idle')

      localStorage.clear()

      resetRedux()
      hideLoader && hideLoader(false)
      showModal({
        hideButtonCancel: true,
        message:
          error.response?.mensagem ||
          error.response?.data?.mensagem ||
          error.mensagem ||
          error.message ||
          'Erro ao entrar no sistema.',
        titleModal: ' ',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
  }
  /**
   *
   * LOGIN
   *
   */

  /**
   *
   * DESCRIPT TOKEN
   *
   */

  const handleDescript = (data: any) =>
    !data ? null : JSON.parse(window.atob(data))
  const handleToken = useCallback(() => {
    const tokenDescrited = jwt.decode(token)
    setAllData(tokenDescrited)
    const user = handleDescript(tokenDescrited?.Usuario)
    setUser(user)
    const csn = handleDescript(tokenDescrited?.Csn)
    setUsuarioCsn(csn)
    const fornecedor = handleDescript(tokenDescrited?.Fornecedor)
    setUsuarioFornecedor(fornecedor)

    if (tokenDescrited?.Perfil === 'Fornecedor') {
      setTipoUsuario('Fornecedor')
      return
    }

    if (tokenDescrited?.Perfil === 'Csn' && user?.PerfilUsuarioId) {
      if (
        [
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNCONTRAPARTE,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.CSNSEGURANCALOGICA
        ].includes(user.PerfilUsuarioId)
      ) {
        setTipoUsuario('NGT')
        return
      }
      if (
        [PERMITIONS.GSTANALISTA, PERMITIONS.GSTNORMATIVO].includes(
          user.PerfilUsuarioId
        )
      ) {
        setTipoUsuario('GST')
        return
      }
    }
  }, [token, isLogged])
  useEffect(() => {
    !allDatadescripted && handleToken()
  }, [handleToken])

  /**
   *
   * DESCRIPT TOKEN
   *
   */

  /**
   *
   * CHECK STATE SESSION
   * SE USUARIO LOGADO FOR CSN VERIFICAR SE SESSAO E A MESMA
   * SE SESSAO FOR A MESMA NAO FAZ NADA
   * SE FOR DIFERENTE TIRA DO SISTEMA PARA FAZER LOGIN NOVAMENTE
   * SE FOR FORNECEDOR ELE PODE PERSISTIR
   */

  const handleCheckLogin = useCallback(() => {
    const sessionState = sessionStorage.getItem('csn-session') || 'false'
    if (allDatadescripted?.Perfil === 'Csn' && sessionState !== 'true') {
      localStorage.clear()
      sessionStorage.clear()
      resetRedux()
      push('/')
      return
    }
  }, [allDatadescripted])
  useEffect(handleCheckLogin, [handleCheckLogin])
  /**
   *
   * CHECK STATE SESSION
   *
   */

  /**
   *
   * LOGOUT
   *
   */
  const logout = () => {
    localStorage.clear()
    sessionStorage.clear()
    resetRedux()
    push('/')

    const logout = localStorage.getItem('logout');

    if (!logout || logout.length <= 0)
      localStorage.setItem('logout', 'logout')
  }
  /**
   *
   * LOGOUT
   *
   */
  const resetRedux = () => {
    setUser(null)
    setAllData(null)
    setUsuarioFornecedor(null)
    setUsuarioCsn(null)
    setIsLogged(false)
    setToken(null)
  }
  return (
    <AuthContext.Provider value={{ handleLogin, isLogged, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export interface IAuthContext {
  handleLogin: (_data, hideLoader?: (boolean) => void) => void
  isLogged: boolean
  logout: () => void
}
